<template>
  <div class="text-left word-break">
    <Typography variant="h-4" class="pb-6"
      ><v-icon color="error" class="pr-2 pb-1">mdi-alert-circle</v-icon
      >{{ errorMessage }}</Typography
    >
    <div v-if="isOne10RewardsError">
      <Typography variant="body-1" class="pb-2">
        This person already has a One10 Points account.<br />Please go back and enter a different
        email address to continue.
      </Typography>
    </div>
    <div v-else>
      <CustomerServiceContact />
    </div>
    <div class="d-flex align-center pt-4">
      <Button class="mt-3 mr-4" :color="color" text @click="close"> Close </Button>
      <Button :color="color" @click="goBack" class="mt-3"> Go back </Button>
    </div>
  </div>
</template>

<script>
import Typography from "@/components/generic/Typography";
import CustomerServiceContact from "@/components/help/CustomerServiceContact.vue";
import Button from "@/components/generic/Button.vue";

export default {
  name: "ErrorScreen",
  components: {
    Typography,
    CustomerServiceContact,
    Button,
  },
  props: {
    errorMessage: {
      type: String,
      default: "Looks like there was a problem",
    },
    isOne10RewardsError: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: "brandPrimary",
    },
  },
  emits: ["goBack", "close"],
  methods: {
    goBack() {
      this.$emit("goBack");
    },
    close() {
      this.$emit("close");
    },
  },
};
</script>
